'use es6';

import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";
import { jsx as _jsx } from "react/jsx-runtime";

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n    display: none;\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import pumpkin from 'bender-url!../../../img/pumpkin.svg';
import { TabletAndBelow } from '../themes/mixins';
var LowerRight = styled.div.withConfig({
  displayName: "Pumpkin__LowerRight",
  componentId: "k43hfl-0"
})(["position:absolute;width:auto;right:10px;bottom:0;z-index:100;", ""], TabletAndBelow(_templateObject()));
export var Pumpkin = function Pumpkin() {
  return /*#__PURE__*/_jsx(LowerRight, {
    children: /*#__PURE__*/_jsx("img", {
      src: pumpkin
    })
  });
};